import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import BLUETOOTH_STATUS from 'constants/bluetooth';
import { ZONES } from 'constants/video';
var percentPerZone = 20;
export var isChromecastDeviceAvailable = function isChromecastDeviceAvailable() {
  return global.cast && global.cast.framework && global.cast.framework.CastContext.getInstance().getCastState() !== global.cast.framework.CastState.NO_DEVICES_AVAILABLE;
};
export var isDisconnected = function isDisconnected(device) {
  return [BLUETOOTH_STATUS.DEVICE_CONNECTED, BLUETOOTH_STATUS.READY_TO_CAST, BLUETOOTH_STATUS.UNINITIALIZED, BLUETOOTH_STATUS.ADMIN].indexOf(device.status) === -1 || device.disconnected;
};
export var isInTarget = function isInTarget(percentage, targetZone) {
  return targetZone && percentage <= targetZone.max_percent && percentage >= targetZone.min_percent;
};
export var getZoneIndex = function getZoneIndex(percentage) {
  return percentage > 100 ? ZONES.length - 1 : Math.max(ZONES.findIndex(function (z) {
    return percentage > z.min && percentage <= z.max;
  }), 0);
};
export var positionInZoneBar = function positionInZoneBar(percentage) {
  percentage = Math.max(Math.min(percentage, 100), 0);
  var i = Math.max(ZONES.findIndex(function (z) {
    return percentage > z.min && percentage <= z.max;
  }), 0);
  var calculated = percentPerZone * i + (percentage - ZONES[i].min) / (ZONES[i].max - ZONES[i].min) * percentPerZone;
  return Math.max(Math.min(calculated, 100), 0);
};
export var calculateTargetWidth = function calculateTargetWidth(targetZone) {
  return _typeof(targetZone) === 'object' ? Math.max(positionInZoneBar(targetZone.max_percent) - positionInZoneBar(targetZone.min_percent), 0) : 0;
};